module.exports = __webpack_public_path__ + "img/199.8eca82b4.jpg";